import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
let promise = Promise.all([parcelRequire.load("4XBUW")]).then(() => {
let originalModule = parcelRequire("4aS67");
let resources = <link rel="modulepreload" href={parcelRequire.resolve("4XBUW")} />;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
